// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__mbk7T","title":"Slider_title__DJ90k","subTitle":"Slider_subTitle__CcDGh","sliderContainer":"Slider_sliderContainer__q7dQ5"};